<div class="list-scroll-container">
    <li *ngFor="let layer of layers; let i = index" fxLayout="row" fxLayoutAlign="space-evenly center" class="layer-control">
        <p>
        <mat-icon style="margin-right:5px;margin-bottom:-5px;cursor: pointer;" *ngIf="layer.visible"(click)="setVisible(layer, false)">visibility</mat-icon>
        <mat-icon style="margin-right:5px;margin-bottom:-5px;cursor: pointer;" *ngIf="!layer.visible" (click)="setVisible(layer, true)">visibility_off</mat-icon>
        <mat-icon style="margin-right: 5px;margin-bottom:-5px;" *ngIf="layer.showLegend" title="{{ 'layer-control.legend-title' | translate }}">legend_toggle</mat-icon> 
        <mat-icon style="margin-right: 5px;margin-bottom:-5px;min-width: 15px;" *ngIf="!layer.showLegend"></mat-icon>
        
        <mat-label style="min-width: 40px;">{{ layer.title }}</mat-label>
        <mat-slider
              max=1
              min=0
              step=0.1
              thumbLabel="thumbLabel"
              [(ngModel)]="layer.opacity"
              (change)="onChange(layer)"
              >
          </mat-slider>
          
          <app-area-group-type-dropdown
            *ngIf="layer.showDropDown && layer.visible"
            (selectedChange)="this.setSelectedAreaGroupType($event, layer)"
            [required]="true"
            [singleSelection]="true"
            [selected]="[layer.selectedDropdown ? layer.selectedDropdown.replace('GROUP_', '') : this.defaultStressGroup]"
      ></app-area-group-type-dropdown></p>
    </li>
</div>
